import React from 'react';
import { useApp } from '../../context/AppContext';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { COLLS } from '../../constants';

export default function DealRoomScreen() {
  const { playbooks, go, setActivePbIdx, toast } = useApp();
  const { isMobile, rp } = useBreakpoint();
  const sentPlaybooks = playbooks.filter(pb => pb.status === 'sent');
  const px = rp({ mobile: '14px', tablet: '18px', desktop: '24px' });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: `14px ${px}`, borderBottom: '1px solid var(--border)', flexShrink: 0, background: 'white' }}>
        <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: '#EDE9FE', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <i className="ti ti-building" style={{ fontSize: '18px', color: '#7C3AED' }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: rp({ mobile: '16px', desktop: '20px' }), fontWeight: '800', color: 'var(--navy)' }}>Deal Rooms</div>
          {!isMobile && <div style={{ fontSize: '12px', color: 'var(--text3)' }}>All active deal workspaces</div>}
        </div>
        {!isMobile && (
          <div style={{ display: 'flex', gap: '16px' }}>
            {[{ label: 'Active', value: sentPlaybooks.length, color: '#22C55E' }, { label: 'Views today', value: 12, color: 'var(--navy)' }, { label: 'Hot', value: 2, color: '#EF4444' }].map(s => (
              <div key={s.label} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '18px', fontWeight: '800', color: s.color }}>{s.value}</div>
                <div style={{ fontSize: '10px', color: 'var(--text3)' }}>{s.label}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Alert banner */}
      <div style={{ padding: `8px ${px}`, background: '#FFFBEB', borderBottom: '1px solid #FDE68A', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
          <i className="ti ti-bell-ringing" style={{ fontSize: '14px', color: '#B45309', flexShrink: 0, marginTop: '1px' }} />
          <span style={{ fontSize: '12px', color: '#92400E', fontWeight: '600', lineHeight: 1.4 }}>Priya Sharma is viewing Q2 Product Pitch — 8 min on pricing 🔥</span>
        </div>
      </div>

      {/* Cards */}
      <div style={{ flex: 1, overflowY: 'auto', padding: `16px ${px}` }}>
        <div style={{ display: 'grid', gridTemplateColumns: rp({ mobile: '1fr', tablet: '1fr 1fr', desktop: 'repeat(auto-fill,minmax(300px,1fr))' }), gap: '14px', alignContent: 'start' }}>
          {sentPlaybooks.map((pb, idx) => {
            const colls = (pb.colls || []).map(i => COLLS[i]).filter(Boolean);
            const globalIdx = playbooks.indexOf(pb);
            return (
              <div key={idx} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '14px', overflow: 'hidden', transition: 'all .18s' }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,.1)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = ''; e.currentTarget.style.transform = ''; }}>
                {/* Colored header */}
                <div style={{ padding: '14px 16px', background: pb.dealRoom.color, minHeight: '72px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '6px', gap: '8px' }}>
                    <div style={{ fontSize: '14px', fontWeight: '700', color: 'white', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pb.dealRoom.label}</div>
                    <span style={{ fontSize: '9px', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: pb.dealRoom.accent + '30', color: pb.dealRoom.accent, border: `1px solid ${pb.dealRoom.accent}60`, flexShrink: 0 }}>{pb.dealRoom.stage}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <i className={`ti ${pb.dealRoom.stageIco}`} style={{ color: pb.dealRoom.accent, fontSize: '12px' }} />
                    <span style={{ fontSize: '11px', color: 'rgba(255,255,255,.65)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pb.name}</span>
                  </div>
                </div>

                <div style={{ padding: '12px 16px' }}>
                  {/* Recipients */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginBottom: '10px', flexWrap: 'wrap' }}>
                    {pb.recipients.map((r, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: 'var(--navy)', color: 'var(--gold)', fontSize: '8px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{r.ini}</div>
                        <div>
                          <div style={{ fontSize: '11px', fontWeight: '600', color: 'var(--navy)' }}>{r.name}</div>
                          <div style={{ fontSize: '10px', color: 'var(--text3)' }}>{r.org}</div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Stats */}
                  <div style={{ display: 'flex', gap: '12px', marginBottom: '10px' }}>
                    {[{ val: pb.views, label: 'Views' }, { val: pb.opens, label: 'Opens' }, { val: colls.length, label: 'Files' }].map(s => (
                      <div key={s.label} style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '16px', fontWeight: '800', color: 'var(--navy)' }}>{s.val}</div>
                        <div style={{ fontSize: '9px', color: 'var(--text3)', fontWeight: '600', textTransform: 'uppercase' }}>{s.label}</div>
                      </div>
                    ))}
                  </div>

                  {/* Security badges */}
                  <div style={{ display: 'flex', gap: '4px', marginBottom: '10px', flexWrap: 'wrap' }}>
                    {pb.security.otp && <span style={{ fontSize: '9px', fontWeight: '700', padding: '2px 7px', borderRadius: '20px', background: '#EBF8FF', color: '#1E4E8C' }}>🔐 OTP</span>}
                    {pb.security.expiry && <span style={{ fontSize: '9px', fontWeight: '700', padding: '2px 7px', borderRadius: '20px', background: '#FDF4E7', color: '#7A5A1A' }}>⏱ {pb.security.expiry}</span>}
                    {pb.security.blockFwd && <span style={{ fontSize: '9px', fontWeight: '700', padding: '2px 7px', borderRadius: '20px', background: '#FFF5F5', color: '#C53030' }}>🚫 No fwd</span>}
                  </div>

                  {/* Actions */}
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button onClick={() => { setActivePbIdx(globalIdx); go('client'); }} style={{ flex: 1, padding: '8px', borderRadius: '8px', background: 'var(--navy)', border: 'none', color: 'white', fontFamily: 'inherit', fontSize: '11px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                      <i className="ti ti-eye" /> Open
                    </button>
                    <button onClick={() => toast('Analytics opened')} style={{ flex: 1, padding: '8px', borderRadius: '8px', border: '1.5px solid var(--border2)', background: 'white', fontFamily: 'inherit', fontSize: '11px', color: 'var(--text2)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                      <i className="ti ti-chart-bar" /> Stats
                    </button>
                    <button onClick={() => toast('Link copied!')} style={{ padding: '8px 10px', borderRadius: '8px', border: '1.5px solid var(--border2)', background: 'white', fontFamily: 'inherit', fontSize: '11px', color: 'var(--text2)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <i className="ti ti-share" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
